import * as React from 'react';
import { Combobox as ComboboxPrimitive } from '@base-ui/react';

/**
 * In the non-virtualized case, Base UI owns both filtering and row rendering.In a virtualized case, this gets replaced with a manual react-virtual loop. Once we do that, something still needs to tell our loop which items Base UI currently considers filtered, which is exactly what this hook provides.
 */
export function useComboboxFilteredItems<Value>(): readonly Value[] {
  return ComboboxPrimitive.useFilteredItems<Value>();
}

/**
 * Returns a ref to be used as the Combobox trigger anchor for positioning
 * popup/content. Attach this ref to the trigger element so the Combobox can
 * align the dropdown correctly.
 */
export function useComboboxAnchor() {
  return React.useRef<HTMLDivElement | null>(null);
}
